import { FC } from "react"

const HorizontalMenuForm: FC<HorizonralFormProps> = (props) => {
    return (
        <>
            {props.menus?.map((item: menuHorizontal, key: number) => {
                return (
                    <div key={key} className={(item.isCurrent)?'stepper-item current':'stepper-item'} data-kt-stepper-element='nav'>
                        <h3 className='stepper-title'>{item.text}</h3>
                    </div>
                )
            })}
        </>
    )
}
interface HorizonralFormProps {
    menus: menuHorizontal[]
}
export interface menuHorizontal {
    text:string,
    isCurrent?:boolean
}
export { HorizontalMenuForm }